<div class="container-decline">
    <p mat-dialog-title class="container-decline__title">{{ 'signaturit_pro.declineModal.title' | translate:_transParam }}</p>
    <p>{{ 'signaturit_pro.declineModal.textarea' | translate:_transParam }}</p>
    <textarea
        class="container-decline__textArea"
        [(ngModel)]="textAreaValue"
        (ngModelChange)="updateTextAreaValue($event)"
        [maxlength]="maxNumberOfCharacters"
        placeholder="{{ 'signaturit_pro.declineModal.textarea_placeholder' | translate:_transParam }}"
        [attr.disabled]="disableTextArea ? '' : null"
        rows="5"
    ></textarea>
    <div mat-dialog-actions class="container-decline__actions">
        <button mat-button class="container-decline__actions--button-cancel" (click)="closeModal(false)">{{ 'signaturit_pro.declineModal.button_close' | translate:_transParam }}</button>
        <button mat-button class="container-decline__actions--button-confirm" [disabled]="disableDecline" (click)="closeModal(true)">{{ 'signaturit_pro.declineModal.button_accept' | translate:_transParam }}</button>
    </div>
</div>